import { FilterModalTypes } from '../../components/FilterModal';
import { SectionTypes } from '../../components/FilterModal/filters/Section';

export const dateFilterFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Período',
  fieldName: 'dateFilter',
  options: [
    { label: 'Últimos 30 dias', value: 'Last30Days' },
    { label: 'Últimos 60 dias', value: 'Last60Days' },
    { label: 'Últimos 90 dias', value: 'Last90Days' },
    { label: 'Últimos 12 meses', value: 'Last360Days' },
    { label: 'Outro', value: 'Other' },
  ],
  selection: ['Last30Days'],
  optionsColumns: 1,
  onlyOneSelection: true,
  optionWidth: 'full',
};

export const orderSideFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Tipo',
  fieldName: 'orderSide',
  options: [
    { label: 'Aplicação/Compra', value: 'C' },
    { label: 'Resgate/Venda', value: 'V' },
  ],
  optionsColumns: 1,
  optionWidth: 'full',
};

export const sendDateFilter: FilterModalTypes.FilterType = {
  type: 'dateRange',
  title: 'Data de envio',
  fieldName: 'sendDate',
  placeholder: 'Selecione a data',
  maxDaysRange: 730,
  showOnlyIf: (selectedFilters) => {
    const dateFilterSelected = selectedFilters.find((filter) => filter.fieldName === 'dateFilter');
    return (dateFilterSelected?.filter as SectionTypes.SelectionProps)?.includes('Other');
  },
};

export const productFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Produto',
  fieldName: 'product',
  options: [
    { label: 'Renda Fixa', value: 'FixedIncome' },
    { label: 'Renda Variável', value: 'Equity' },
    { label: 'Fundos', value: 'Fund' },
    { label: 'Tesouro Direto', value: 'Treasury' },
    { label: 'Produtos Estruturados', value: 'COE' },
  ],
};

export const orderStatusFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Status',
  fieldName: 'status',
  options: [
    { label: 'Enviada', value: 'SentAndPendingExecution' },
    { label: 'Notificada', value: 'NotifiedAndPendingAcceptance' },
    { label: 'Á liquidar', value: 'ExecutedAndPendingSettlement' },
    { label: 'Liquidada', value: 'SettledAndSettled' },
    { label: 'Cancelada', value: 'CancelledAndCancelled' },
    { label: 'Rejeitada', value: 'RejectedAndRejected' },
    { label: 'Expirada', value: 'ExpiredAndExpired' },
    { label: 'Erro', value: 'ErrorAndError' },
    { label: 'Aceita', value: 'AcceptedAndPendingExecution' },
    { label: 'Parc. Liquidada', value: 'PartiallyExecutedAndPartiallyExecuted' },
  ],
};

export const estimatedValueFilter: FilterModalTypes.FilterType = {
  type: 'range',
  title: 'Total estimado',
  fieldName: 'estimatedValue',
  labelType: 'money',
  max: 10000000,
  min: 0,
};
